<template>
  <div class="lottie-container">
    <vue-lottie-player
      autoplay
      loop
      mode="normal"
      path="https://assets2.lottiefiles.com/packages/lf20_msa6voq8.json"
      width="85px"
      height="82px"
      name="mail"
    />
  </div>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";
export default {
  name: "PasswordChangedIcon",
  components: {
    VueLottiePlayer,
  },
};
</script>

<style lang="scss" scoped>
</style>
